'use client';

import { useTranslations } from 'next-intl';
import type { Resolution } from '@/lib/api/event/models';
import { useApiTranslation } from '@/lib/hooks/useApiTranslation';
import { Icon } from '@/lib/ui-kit/icons';

interface ResolutionTimelineProps {
  resolutions: Resolution[];
}

export function ResolutionTimeline({ resolutions }: ResolutionTimelineProps) {
  const t = useTranslations('event.resolution');
  const { tr } = useApiTranslation();

  // Both "proposed" and "final" show the winning resolution.
  // The resolutions array contains both sides (e.g. Yes + No);
  // pick the one marked isWin, falling back to the first entry.
  const winner = resolutions.find((r) => r.isWin) ?? resolutions[0];
  const winnerName = winner ? tr(winner.translations, 'name', winner.name) : '—';

  const steps = [
    { label: t('outcomeProposed', { value: winnerName }) },
    { label: t('finalOutcome', { value: winnerName }) },
  ];

  return (
    <div className="flex flex-col gap-2 px-4 pb-4">
      {steps.map((step, index) => (
        <div key={index} className="flex items-center gap-2">
          <div className="relative flex flex-col items-center">
            <div className="bg-primary flex h-5 w-5 items-center justify-center rounded-full">
              <Icon name="Check" size={10} className="text-white" />
            </div>
            {index < steps.length - 1 && (
              <div className="bg-primary absolute top-[20px] h-[12px] w-[2px] rounded-full" />
            )}
          </div>
          <span className="text-txt-1 text-xs font-medium leading-[14px]">{step.label}</span>
        </div>
      ))}
    </div>
  );
}
